function ProfilePage({
  title = "Account Desk",
  description = "",
  metricsNode = null,
  message = "",
  error = "",
  primaryNode = null,
  sideNode = null,
  children = null,
  profileSummary = null,
}) {
  return (
    <section id="account" className="appRoutePage profileRoutePage productSection">
      <div className="routePageHeader profilePageHeader">
        <div className="profilePageHero">
          <div className="profileAvatarShell" aria-hidden="true">
            {profileSummary?.initial || "P"}
          </div>
          <div className="profilePageHeroCopy">
            <span className="leaguePageEyebrow">{title}</span>
            <h1>{profileSummary?.name || title}</h1>
            <p>{description}</p>
            {profileSummary ? (
              <div className="profilePageHeroMeta">
                {profileSummary.email ? <span>{profileSummary.email}</span> : null}
                {profileSummary.country ? <span>{profileSummary.country}</span> : null}
                {profileSummary.joinedLabel ? <span>{profileSummary.joinedLabel}</span> : null}
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {metricsNode}
      {message ? <p className="successMessage">{message}</p> : null}
      {error ? <p className="errorMessage">{error}</p> : null}
      {profileSummary?.platforms?.length ? (
        <div className="profilePlatformDeck">
          {profileSummary.platforms.map((platform) => (
            <div key={`profile-platform-${platform.label}`} className="profilePlatformCard">
              <small>{platform.label}</small>
              <strong>{platform.value}</strong>
              {platform.note ? <span>{platform.note}</span> : null}
            </div>
          ))}
        </div>
      ) : null}
      <div className="sectionGrid twoColumn">
        {children || (
          <>
            {primaryNode}
            {sideNode}
          </>
        )}
      </div>
    </section>
  );
}

export default ProfilePage;
